<template>
  <div>
    <v-card color="grey lighten-5 ma-0 pa-0" :loading="loading">
      <DocumentActionHeader
        :title="$t('CertifiedSignatures')"
        @on-close-click="onCloseClick"
      />

      <v-card-text class="overflow-y-auto" style="max-height: 250px">
        <template v-for="signature in signatureList">
          <SignatureItem :signature="signature" v-bind:key="signature.date" />
        </template>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import DocumentActionHeader from '@/components/search/results/list/item/actions/DocumentActionHeader';
import SignatureItem from '@/components/search/results/list/item/actions/signature/SignatureItem';
import DocumentService from '@/services/DocumentService';
import Signature from '@/ecm/models/search/results/list/Signature';

export default {
    components: {
        DocumentActionHeader,
        SignatureItem,
    },
    props: {
        documentId: {
            type: Number,
            required: true,
        },
    },
    created() {
        this.loadData();
    },
    data() {
        return {
            signatureList: [],
            loading: false,
        };
    },
    methods: {
        onCloseClick() {
            this.$emit('on-close-click');
        },
        loadData() {
            this.loading = true;
            DocumentService.getSignatureList(this.documentId).then((data) => {
                this.signatureList = data.map(function (dto) {
                    return new Signature(dto);
                });
                this.loading = false;
            });
        },
    },
};
</script>